export enum FileCategoryVisibilityGroup {
  FEE_FOR_LIFE = 'fee_for_life',
}
